import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SettingsEditPackageService } from '@app/pages/settings/packages/edit-package/edit-package.service';
import { SettingsPackageConditionComponent } from '@app/pages/settings/packages/edit-package/package-condition/package-condition.component';
import { SettingsPackageDetailsComponent } from '@app/pages/settings/packages/package-details/package-details.component';
import { BoxService } from '../../services/boxes/box.service';
import { SettingsService } from '../../services/settings/settings.service';
import { SharedModule } from '../../sharedModule/shared.module';
import { StorybookModule } from '../../storybook/storybook.module';
import { AccountPageComponent } from './Account/account-page.component';
import { ResetStoreDialogComponent } from './Account/reset-store-dialog/reset-store-dialog.component';
import { SyncProductsDialogComponent } from './Account/sync-products-dialog/sync-products-dialog.component';
import { BillingHistoryComponent } from './billing/billing-history/billing-history.component';
import { BillingOverviewComponent } from './billing/billing-overview/billing-overview.component';
import { BillingPlansComponent } from './billing/billing-plans/billing-plans.component';
import { PaymentMethodChooserDialogComponent } from './billing/billing-plans/payment-method-chooser-dialog/payment-method-chooser-dialog.component';
import { PlanConfirmationComponent } from './billing/billing-plans/plan-confirmation/plan-confirmation.component';
import { BillingComponent } from './billing/billing.component';
import { IncotermComponent } from './international/incoterm/incoterm.component';
import { InternationalComponent } from './international/international.component';
import { AddTaxIdDialog } from './international/tax/dialog/add-tax-id/add-tax-id.dialog';
import { TaxComponent } from './international/tax/tax.component';
import { LocationCardComponent } from './locations/location-card/location-card.component';
import { LocationEditComponent } from './locations/location-edit/location-edit.component';
import { CustomShippingDayComponent } from './locations/location-edit/custom-shipping-day/custom-shipping-day.component';
import { LocationsComponent } from './locations/locations.component';
import { NotificationsPageComponent } from './notifications/notifications-page.component';
import { DeletePackageComponent } from './packages/delete-package/delete-package.component';
import { SettingsEditCarrierPackageComponent } from './packages/edit-package/edit-carrier-package/edit-carrier-package.component';
import { SettingsEditCustomPackageComponent } from './packages/edit-package/edit-custom-package/edit-custom-package.component';
import { CanDeactivateEditPackageGuard } from './packages/edit-package/edit-package-guard/deactivate-edit-package-gurad';
import { EditPackageGuardComponent } from './packages/edit-package/edit-package-guard/edit-package-guard.component';
import { SettingsEditPackageComponent } from './packages/edit-package/edit-package.component';
import { SettingsPackagesComponent } from './packages/packages.component';
import { SettingsPdqIqComponent } from './packages/pdq-iq/pdq-iq.component';
import { SettingsMenuComponent } from './settings-menu/settings-menu.component';
import { SettingsPageComponent } from './settings-page/settings-page.component';
import { SettingsRouterModule } from './settings-router.module';
import { UserDetailsComponent } from './users-and-permissions/user-details/user-details.component';
import { UsersAndPermissionsComponent } from './users-and-permissions/users-and-permissions.component';
import { UsersTableComponent } from './users-and-permissions/users-table/users-table.component';
import { VerificationsComponent } from './verifications/verifications.component';
import { IntegrationsModule } from './integrations/integrations.module';
import { LinkUpModule } from '@settings/link-up/link-up.module';
import { NotificationsInternalComponent } from './notifications/notifications-internal/notifications-internal.component';
import { RouterModule } from '@angular/router';
import { MaxxSettingsPageComponent } from './maxx/maxx-settings-page.component';
import { MaxxSlackSettingsComponent } from './maxx/maxx-slack-settings/maxx-slack-settings.component';
import { MaxxCapabilitiesSettingsComponent } from './maxx/maxx-capabilities-settings/maxx-capabilities-settings.component';
import { MaxxBrandKitSettingsComponent } from './maxx/maxx-brand-kit-settings/maxx-brand-kit-settings.component';
import { TruncateTextDirective } from './maxx/maxx-capabilities-settings/truncate-text.directive';
import { MaxxMonitoringSettingsComponent } from './maxx/maxx-monitoring-settings/maxx-monitoring-settings.component';
import { MaxxMonitorFormComponent } from './maxx/maxx-monitor-form/maxx-monitor-form.component';

@NgModule({
  imports: [
    CommonModule,
    TruncateTextDirective,
    StorybookModule,
    SharedModule,
    SettingsRouterModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatSlideToggleModule,
    IntegrationsModule,
    MatAutocompleteModule,
    LinkUpModule,
    RouterModule,
  ],
  declarations: [
    SettingsPageComponent,
    SettingsMenuComponent,
    AccountPageComponent,
    VerificationsComponent,
    NotificationsPageComponent,
    BillingComponent,
    BillingOverviewComponent,
    BillingHistoryComponent,
    BillingPlansComponent,
    PaymentMethodChooserDialogComponent,
    PlanConfirmationComponent,
    SettingsPackagesComponent,
    SettingsEditPackageComponent,
    SettingsEditCustomPackageComponent,
    SettingsEditCarrierPackageComponent,
    SettingsPackageConditionComponent,
    SettingsPackageDetailsComponent,
    SettingsPdqIqComponent,
    LocationsComponent,
    LocationCardComponent,
    LocationEditComponent,
    CustomShippingDayComponent,
    EditPackageGuardComponent,
    DeletePackageComponent,
    ResetStoreDialogComponent,
    SyncProductsDialogComponent,
    InternationalComponent,
    TaxComponent,
    IncotermComponent,
    AddTaxIdDialog,
    UsersAndPermissionsComponent,
    UsersTableComponent,
    UserDetailsComponent,
    NotificationsInternalComponent,
    MaxxSettingsPageComponent,
    MaxxSlackSettingsComponent,
    MaxxCapabilitiesSettingsComponent,
    MaxxBrandKitSettingsComponent,
    MaxxMonitoringSettingsComponent,
    MaxxMonitorFormComponent,
  ],
  providers: [SettingsService, BoxService, SettingsEditPackageService, CanDeactivateEditPackageGuard],
})
export class SettingsModule {}
